import React from 'react';
import styled from 'styled-components';
import Listado from './components/lista';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Suscripciones = () => (
  <Container>
    <h2>Suscripciones</h2>
    <Listado />
  </Container>
);
